import { apiFetch, apiRequest } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const policies = createWorkspaceResourceApi('policies')
const builders = createWorkspaceResourceApi('policy-builders')
const multipart = { 'Content-Type': 'multipart/form-data' }
const ws = (workspaceId) => `workspaces/${workspaceId}`

export const policiesApi = {
  list: policies.list,
  get: policies.get,
  remove: policies.remove,
  names: (workspaceId, params, { signal } = {}) =>
    apiFetch(`${policies.path(workspaceId)}/names`, { params, signal }),
  create: (workspaceId, payload) =>
    apiFetch(policies.path(workspaceId), { method: 'POST', body: payload, headers: multipart }),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, id, payload) =>
    apiFetch(`${policies.path(workspaceId)}/${id}`, {
      method: 'POST',
      body: { ...payload, _method: 'put' },
      headers: multipart,
    }),
  renew: (workspaceId, id, payload) =>
    apiFetch(`${policies.path(workspaceId)}/${id}/renew`, {
      method: 'POST',
      body: { ...payload },
      headers: multipart,
    }),
  updateStatus: (workspaceId, id, payload) =>
    apiFetch(`${policies.path(workspaceId)}/${id}/update-status`, { method: 'PUT', body: payload }),
  bulkUpdateStatus: (workspaceId, payload) =>
    apiFetch(`${policies.path(workspaceId)}/bulk-update-status`, { method: 'POST', body: payload }),
  sendEmail: (workspaceId, id, payload) => policies.action(workspaceId, id, 'send-email', payload),
  generateReport: (workspaceId, id, formData) =>
    apiFetch(`${policies.path(workspaceId)}/${id}/report`, {
      method: 'POST',
      body: formData,
      headers: multipart,
    }),
  finalizeDocument: (workspaceId, id, payload) =>
    apiFetch(`${policies.path(workspaceId)}/${id}/documents/finalize`, {
      method: 'POST',
      body: payload,
      ignoreGlobalCatch: true,
    }),
  answerFromFile: (workspaceId, formData) =>
    apiFetch(`${policies.path(workspaceId)}/answer-from-file`, {
      method: 'POST',
      body: formData,
      headers: multipart,
    }),
  deleteFile: (workspaceId, fileId) =>
    apiFetch(`${ws(workspaceId)}/files/${fileId}`, { method: 'DELETE' }),

  // Policy builders
  builders: builders.list,
  generate: builders.create,
  updateBuilderResponse: (workspaceId, payload) =>
    apiFetch(`${builders.path(workspaceId)}/response`, { method: 'POST', body: payload }),

  /** Policy-builder document content (the Tiptap editor reads and writes it). */
  builderDocument: (workspaceId, fileId, { signal } = {}) =>
    apiFetch(`${builders.path(workspaceId)}/${fileId}`, { signal }),
  saveBuilderDocument: (workspaceId, fileId, content) =>
    apiFetch(`${builders.path(workspaceId)}/${fileId}`, { method: 'POST', body: { content } }),
  /** Exports the builder document; resolves the full response (Blob in `data`). */
  exportBuilderDocument: (workspaceId, fileId, payload) =>
    apiRequest(`${builders.path(workspaceId)}/export/${fileId}`, {
      method: 'POST',
      body: payload,
      responseType: 'blob',
    }),

  // Builder form questions
  formTags: (workspaceId, type, { signal } = {}) =>
    apiFetch(`${ws(workspaceId)}/workspace-forms/${type}/tags`, { signal }),
  formQuestions: (workspaceId, payload) =>
    apiFetch(`${ws(workspaceId)}/workspace-forms/questions`, { method: 'POST', body: payload }),

  // Global lookups
  types: (params) => apiFetch('policy-types', { params }),
  questionDuplicates: (params, { signal } = {}) =>
    apiFetch('form-templates/question-duplicates', { params, signal }),
  deleteQuestionDuplicates: (payload) =>
    apiFetch('form-templates/question-duplicates', { method: 'POST', body: payload }),
}
